// extracted by mini-css-extract-plugin
module.exports = {"container":"Components_container__2sA9q","header":"Components_header__1WSuZ"};